import { ReactElement } from 'react';

import { Toaster } from '@creditornot/alchemy-react';

type Props = {
  duration?: number;
};

export const Snackbars = ({ duration = 3000 }: Props): ReactElement => {
  return <Toaster duration={duration} />;
};
